import React, { useState, useEffect } from "react";
import { SharePopup } from "./SharePopup.jsx";
import { ProposalPopup } from "./ProposalPopup.jsx";
//import defaultAvatar from "../../../../../../osoigonext/static/imgs/avatar2.svg"

export function Proposal({
  proposal,
  answer,
  configuration,
  onAnswered,
}) {
  const [popupVisible, setPopupVisible] = useState(false);
  const [answeredChoice, setAnsweredChoice] = useState(answer);

  let shareButtons = "";
  if (configuration.enableShareButtons) {
    function shareClick(event) {
      document
        .querySelector(`#proposal-${proposal.pk} .share-modal`)
        .classList.add("visible");
    }
    shareButtons = (
      <>

        <a className="share-proposal" onClick={shareClick} title={configuration.translations.shareButton}>
          <i className="icon-compartir" title={configuration.translations.shareButton}></i>
        </a>
        <SharePopup
          url={proposal.detail_url}
          text={proposal.name}
          configuration={configuration}
        />
      </>
    );
  }
  let answerButtons = "";
  if (configuration.enableAnswerButtons) {
    answerButtons = (
      <>
        <div className="answer-options">
          <button
            type="submit"
            name="answer"
            className={answeredChoice === true ? "choosen-answer" : undefined}
            value="1"
            title={configuration.translations.Yes}
          >
            <i className="icon-mano_arriba" title={configuration.translations.Yes}></i>
          </button>
          <button
            type="submit"
            name="answer"
            className={answeredChoice === false ? "choosen-answer" : undefined}
            value="0"
            title={configuration.translations.No}
          >
            <i className="icon-mano_abajo" title={configuration.translations.No}></i>
          </button>
        </div>
      </>
    );
  }
  let proposalTotalOk = "";
  if (proposal.total_ok) {
    proposalTotalOk = (
      <div className="proposal-total-ok">
        <span>{proposal.total_ok}</span>
      </div>
    );
  } else {
    proposalTotalOk = (
      <div className="proposal-total-ok">
        <span>0</span>
      </div>
    );
  }
  let proposalCreator = "";
  if (proposal.creator) {
    proposalCreator = (
      <div className="proposal-creator">
        <img
          src={proposal.creator.avatar}
          alt={proposal.creator.name}
        />
        <span>{proposal.creator.name}</span>
      </div>
    );
  } else {
    proposalCreator = (
        <div className="proposal-creator">
          <svg className="proposal-creator_avatarDefault" width= "30px" height="30px" xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="-1 -1 22 22"><g fill="#034099"><path d="M12.7 19.8H7.3c-1.2 0-2.2-.1-3-.4l-.6-.2.1-.6c.2-2.7 3-4.9 6.3-4.9s6 2.1 6.3 4.9l.1.6-.6.2c-1 .3-2 .4-3.2.4zm-7.4-1.7c.6.1 1.2.2 2 .2h5.4c.7 0 1.4-.1 2-.2-.5-1.7-2.4-2.9-4.7-2.9s-4.1 1.3-4.7 2.9z"/><path d="m5.1 19.7-.9-.2c-3.6-1-4-4.3-4-6.7V7.3C.2 2.4 2.3.2 7.3.2h5.4c4.9 0 7 2.1 7 7.1v5.4c0 2.4-.4 5.7-4 6.7l-.9.2-.1-.9c-.2-2-2.3-3.5-4.8-3.5s-4.6 1.5-4.8 3.5v1zm4.9-5.9c2.9 0 5.4 1.7 6.1 3.9 1.5-.7 2.2-2.2 2.2-5V7.3c0-4.1-1.5-5.6-5.5-5.6H7.3c-4.1 0-5.6 1.5-5.6 5.6v5.4c0 2.7.6 4.2 2.2 5 .7-2.3 3.2-3.9 6.1-3.9zm0-1.1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.3-1.8 4-4 4zm0-6.4c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z"/></g></svg>
          <span>Anónimo</span>
        </div>
      );
  }
  
  function sendProposal(event) {
    event.preventDefault();
    const proposal = event.target.closest("form");
    const value = event.nativeEvent.submitter.value;
    const url = `/api/v1/proposals/${configuration.proposalsetId}/send_vote/`;
    const data = new FormData(proposal);
    const answer = {
        'proposal': data.get('proposal'),
        'answer': value,
    };
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
             'X-CSRFToken': OsoigoNext.getCookie('csrftoken'),
        },
        body: JSON.stringify(answer),
    };
    fetch(url, options)
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                setAnsweredChoice(value == "1");
                onAnswered(value == "1");
            } else {
                alert(data.error);
            }
        });
  }

  function openProposalPopup(event) {
    setPopupVisible(true);
  }

  let proposalClassName = "proposal-widget";
  if (answeredChoice != null) proposalClassName += " answered";

  function truncate(str, n) {
    return str.length > n ? str.slice(0, n - 1) + " &hellip;" : str;
  }

  let proposalLink;
  let proposalPopup = '';
  if (configuration.openInPopup) {
    proposalLink = (
      <a
        href=""
        className="proposal-info-button"
        onClick={(e) => {
          e.preventDefault();
          openProposalPopup();
        }}
      >
        {configuration.translations.moreInfo}
      </a>
    )
    proposalPopup = (
      <ProposalPopup
        proposal={proposal}
        configuration={configuration}
        popupVisible={popupVisible}
        setPopupVisible={setPopupVisible}
        answeredChoice={answeredChoice}
        sendProposal={sendProposal}
      />
    )
  } else {
    proposalLink = (
      <a href={proposal.detail_url} className="proposal-info-button"> {configuration.translations.moreInfo} </a>
    )
  }

  return (
    <div
      id={`proposal-${proposal.pk}`}
      className={proposalClassName}
      onSubmit={sendProposal}
    >
      {proposalCreator}
      <h1
        dangerouslySetInnerHTML={{ __html: truncate(proposal.name, 70) }}
      ></h1>
      <div
        dangerouslySetInnerHTML={{ __html: proposal.listing_body }}
      ></div>
      <form className="proposal-answer">
        <input type="hidden" name="proposal" value={proposal.pk} />
        {proposalTotalOk}
        {answerButtons}
        {shareButtons}
        {proposalLink}
      </form>
      {proposalPopup}
    </div>
  );
}
